// @file Sets up vue app for the SurfaceProtectedWhiteboardEmbed page
import { captureException } from '@@/bits/error_tracker'
import window, { ww } from '@@/bits/global'
import { setupVueApp } from '@@/bits/vue'
import App from '@@/vuecomponents/SurfaceProtectedWhiteboardEmbed.vue'

setupVueApp({
  el: '#surface_protected_whiteboard_embed',
  rootComponent: App,
  usePinia: true,
  rootComponentProps: () => ({
    showUrl: ww.vueStartingState.showUrl,
    title: ww.vueStartingState.title,
    description: ww.vueStartingState.description,
  }),
})
  .then((vueInstance) => {
    window.app = vueInstance
  })
  .catch(captureException)
